module.exports = __webpack_public_path__ + "img/75732.b326869f.svg";